import React, { useState } from "react";
import type { AscendDrawingSummary } from "../data/ascendDrawings";
import "./AscendDrawings.scss";

export const AscendDrawingsPanel: React.FC<{
  drawings: AscendDrawingSummary[];
  currentId: string | null;
  onOpen: (id: string) => void;
  onDelete: (id: string) => void;
  onClose: () => void;
}> = ({ drawings, currentId, onOpen, onDelete, onClose }) => {
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null);

  return (
    <div className="ascend-panel">
      <div className="ascend-panel__header">
        <strong>My Drawings</strong>
        <button type="button" onClick={onClose}>
          ✕
        </button>
      </div>
      {drawings.length === 0 && (
        <p className="ascend-panel__empty">No saved drawings yet.</p>
      )}
      <ul className="ascend-panel__list">
        {drawings.map((d) => (
          <li key={d.id} className={d.id === currentId ? "active" : ""}>
            <button
              type="button"
              className="ascend-panel__open"
              onClick={() => onOpen(d.id)}
            >
              <span className="ascend-panel__title">{d.name}</span>
              <span className="ascend-panel__date">
                {new Date(d.updatedAt).toLocaleString()}
              </span>
            </button>
            {confirmDeleteId === d.id ? (
              <button
                type="button"
                className="ascend-panel__delete ascend-panel__delete--confirm"
                onClick={() => {
                  onDelete(d.id);
                  setConfirmDeleteId(null);
                }}
                onBlur={() => setConfirmDeleteId(null)}
              >
                Confirm?
              </button>
            ) : (
              <button
                type="button"
                className="ascend-panel__delete"
                onClick={() => setConfirmDeleteId(d.id)}
                aria-label={`Delete ${d.name}`}
              >
                🗑
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
